/* eslint-disable */
import { addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";

const widgets = require.context("../../blueprints/conklin/src/App/GoogleAnalyticsConnector/Widgets", true, /.tsx$/);
addWidgetsFromContext(widgets);
